export const ACT_REFRESH_TOKEN = "refreshToken";
export const ACT_REGISTER_USER = "registerUser";
export const ACT_LOGOUT_USER = "logoutUser";
export const ACT_LOGIN_USER = "loginUser";
export const ACT_SET_SIDECAR_SELECTED = "setSidebarSelected";
export const ACT_CHANGE_STATUS = "changeStatus";
export const ACT_GENERAL_CONFIG = "actGeneralConfig";
export const ACT_SAVE_CONFIG = "actSaveConfig";
